import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Features from './pages/Features';
import Highlights from './pages/Highlights';
import About from './pages/About';
import Contact from './pages/Contact';
import ScrollToTop from './pages/ScrollToTop';
import Login from './Admin/login';
import Dashboard from './Admin/dashboard';

// Layout component WITH header and footer
function MainLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

// Layout component WITHOUT header and footer (for admin routes)
function AdminLayout() {
  return <Outlet />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Routes WITH header and footer */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/highlights" element={<Highlights />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Routes WITHOUT header and footer (Admin routes) */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="dashboard" element={<Dashboard />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
